import { useEffect, useState } from 'react';
import { Table, Badge, Spinner, Alert } from 'react-bootstrap';
import { api } from '../api/client';
import { formatDate } from '../shared/dateFormat';

const BADGE = { present: 'success', absent: 'danger', cancelled: 'secondary' };

export default function AdminManageAttendance() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/admin/attendance').then(setRows).catch((e) => setErr(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-5"><Spinner /></div>;
  if (err) return <Alert variant="danger">{err}</Alert>;

  return (
    <>
      <h3 className="mb-3">Attendance</h3>
      <Table bordered hover responsive className="bg-white">
        <thead className="table-dark"><tr><th>Date</th><th>Student</th><th>Teacher</th><th>Status</th><th>Note</th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={5} className="text-center text-muted">No attendance records yet</td></tr>}
          {rows.map((a) => (
            <tr key={a.id}>
              <td>{formatDate(a.date)}</td><td>{a.student_name}</td><td>{a.teacher_name}</td>
              <td><Badge bg={BADGE[a.status] || 'secondary'}>{a.status}</Badge></td>
              <td>{a.teacher_note || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
